var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.colorCodes
    ? _c(
        "ItpBadge",
        {
          class:
            "bg-" +
            _vm.colorCodes.bg +
            " text-" +
            _vm.colorCodes.text +
            " px-2",
          attrs: {
            "no-box-shadow": "",
            title: _vm.abbreviated ? _vm.tooltipMessage : null
          }
        },
        [
          _vm.invoiceKindIcon
            ? _c("ItpIcon", { attrs: { icon: _vm.invoiceKindIcon } })
            : _vm._e(),
          _vm._v(" "),
          _vm.advance
            ? _c("ItpIcon", {
                attrs: {
                  title: _vm.messages.advanceTooltip,
                  icon: _vm.icons.advance
                }
              })
            : _vm._e(),
          _vm._v(
            "\n" +
              _vm._s(
                _vm.abbreviated
                  ? _vm.messages.abbreviated[_vm.value]
                  : _vm.messages[_vm.value]
              ) +
              "\n\n"
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }